import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { Pagination, Grid } from 'swiper/modules';
export default class ProdutosList {
    constructor() {
        this.sections = document.querySelectorAll('.block-products-list');
        this.ready();
    }

    ready() {

        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');
                const swiper = new Swiper(this.slider, {
                    modules: [Pagination, Grid],
                    grabCursor: true,
                    allowTouchMove: true,
                    spaceBetween: 28,
                    breakpoints: {
                        0: {
                            slidesPerView: 2,
                            grid: {
                                rows: 2,
                                fill: 'row',
                            },
                            slidesPerGroup: 4,
                        },
                        1200: {
                            slidesPerView: 5,
                            grid: {
                                rows: 1,
                            },
                            slidesPerGroup: 5,
                        }
                    },
                    pagination: {
                        el: section.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'bullets'
                    },
                });

            })
        }

    }
}

if (document.querySelector('.block-products-list')) {
    new ProdutosList();
}